import { Component, Input } from '@angular/core';
import { IProject } from '../../interfaces/IProject';

@Component({
  selector: 'eic-project-fid',
  templateUrl: './project-fid.component.html',
  styleUrl: './project-fid.component.scss'
})
export class ProjectFidComponent {
  @Input() fid: IProject['fid'];

  get shouldRenderPendingReceived(): boolean {
    return !!this.fid?.expected && !this.fid?.received;
  }

  get hasVisibleData(): boolean {
    return !!this.fid?.expected || !!this.fid?.received || this.shouldRenderPendingReceived || this.fid?.debtEquityRatio !== undefined && this.fid?.debtEquityRatio !== null;
  }
}
